import type { WorkflowOutput } from "@/types";

export const workflowMock: WorkflowOutput = {
  total: 10,
  items: [
    { status: "created", count: 2, percentage: 20 },
    { status: "pm_review", count: 1, percentage: 10 },
    { status: "drafting", count: 3, percentage: 30 },
    { status: "le_review", count: 2, percentage: 20 },
    { status: "approved", count: 2, percentage: 20 },
  ],
};
